import { TableBody, TableCell, TableRow, Typography } from '@mui/material'
import InvoicesTableRow from './InvoicesTableRow'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function InvoicesTableBody({ rows }) {
  if (rows.length === 0) {
    return (
      <TableBody>
        <TableRow className={shared.tableRowEmptyCells}>
          <TableCell colSpan={6} className={shared.tdEmpty}>
            <Typography variant="body2" color="text.secondary">
              No invoices match your search.
            </Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    )
  }
  return (
    <TableBody>
      {rows.map((row, rowIndex) => (
        <InvoicesTableRow key={row.id} row={row} isLast={rowIndex === rows.length - 1} />
      ))}
    </TableBody>
  )
}
